import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function updateItem(data) {
  return Axios({
    url: `${baseUrl()}/item/${data.id}`,
    method: "PUT",
    data: data,
    headers: {
      Authorization:
        `Bearer ` + (localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).user?.tk : null),
    },
  });
}
